import styled from 'styled-components';

import { device } from '@/styles/helpers';
import { show } from '@/styles/keyframes';

export type GridOptions = {
  columns: number;
  columnsTablet: number;
  columnsMobile: number;
  columnsMobileS: number;
  columnGap: number;
  rowGap: number;
};

export const ScGamesGrid = styled.div`
  transition: all ease 0.3s;
  animation: ${show} 1s ease;

  .loading-ellipsis {
    margin-bottom: 24px;
  }
`;

export const ScGamesGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  & > .show-more-outside {
    width: 280px;
    margin-inline: auto;
  }
`;

export const ScGamesGridRow = styled.div<GridOptions>`
  display: grid;
  grid-auto-rows: 1fr;
  grid-template-columns: ${({ columns }) => `repeat(${columns || 5}, 1fr)`};
  grid-column-gap: ${({ columnGap }) => `${columnGap}px`};
  grid-row-gap: ${({ rowGap }) => `${rowGap}px`};

  @media (${device.tablet}) {
    grid-template-columns: ${({ columnsTablet }) =>
      `repeat(${columnsTablet}, 1fr)`};
  }
  @media (${device.mobile}) {
    grid-template-columns: ${({ columnsMobile }) =>
      `repeat(${columnsMobile}, 1fr)`};
  }
  @media (${device.mobileS}) {
    grid-template-columns: ${({ columnsMobileS }) =>
      `repeat(${columnsMobileS}, 1fr)`};
  }
`;

export interface ScGameItemPlugProps {
  plugGray?: boolean;
  plugBlack?: boolean;
  smallPlugIcon?: boolean;
}
